import React, { useState } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { Modal } from '@frontrunners/ui-components'
import './feedbackSurvey.scss'


export const FeedbackSurvey = () => {
    const { formatMessage: fm } = useIntl()
    const [showModal, setShowModal] = useState(false)

    return (
        <>
            {showModal && <FeedbackModal onClose={() => setShowModal(false)} />}
            <div className="feedback-survey" onClick={() => setShowModal(true)}>
                <p>
                    {fm(FEEDBACK_TEXT['feedback-button'])}
                </p>
            </div>
        </>
    )
}

const FeedbackModal = ({ onClose }) => {
    return (
        <Modal className="feedback-modal" onClose={onClose}>
            <iframe src="https://www.surveyhero.com/e/wvhphsp9" />
        </Modal>
    )
}

const FEEDBACK_TEXT = defineMessages({
    'feedback-button': {
        id: 'feedback-button',
        defaultMessage: 'Feedback',
        description: 'Click to open the feedback survey'
    }
})
